export const templateActions = {
  REACTIVATE: 'Reactivate',
  DEACTIVATE: 'Deactivate'
};

export const WeekEnd = {
  Sunday: 0,
  Saturday: 6
};

export const DayValue = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

// Template slot types that are not bookable patient time. They stay visible on
// the calendar with their own labels, but do not count toward the hours a
// provider is available to see clients.
export const NON_BOOKABLE_AVAILABILITY_TYPES = ['lunch', 'meeting', 'notes'];

export const NON_BOOKABLE_AVAILABILITY_LABEL = 'lunch, meetings and notes';

export const PROVIDER_MAX_DAILY_HOURS_TEMPLATE = 8;

export const FIFTEEN_MINUTES_IN_MS = 15 * 60000;

export const TEN_MINUTES_IN_MS = 10 * 60000;

export const FIVE_MINUTES_IN_MS = 5 * 60000;
